import { render, staticRenderFns } from "./SignAgreement.vue?vue&type=template&id=2ddaf380&scoped=true&"
import script from "./SignAgreement.vue?vue&type=script&lang=js&"
export * from "./SignAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SignAgreement.vue?vue&type=style&index=0&id=2ddaf380&scoped=true&lang=css&"
import style1 from "./SignAgreement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddaf380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddaf380')) {
      api.createRecord('2ddaf380', component.options)
    } else {
      api.reload('2ddaf380', component.options)
    }
    module.hot.accept("./SignAgreement.vue?vue&type=template&id=2ddaf380&scoped=true&", function () {
      api.rerender('2ddaf380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/productEngagement/SignAgreement/SignAgreement.vue"
export default component.exports